export const albumItemActionTypes = {
    //List
	ALBUM_ITEMS_REQUEST: 'ALBUM_ITEMS_REQUEST',
	ALBUM_ITEMS_RECEIVED: 'ALBUM_ITEMS_RECEIVED',
	ALBUM_ITEMS_FAILED: 'ALBUM_ITEMS_FAILED',

	ALBUM_ITEMS_REQUEST_WAIT: 'ALBUM_ITEMS_REQUEST_WAIT',

	ALBUM_PARENT_REQUEST: 'ALBUM_PARENT_REQUEST',
	ALBUM_PARENT_RECEIVED: 'ALBUM_PARENT_RECEIVED',
	ALBUM_PARENT_FAILED: 'ALBUM_PARENT_FAILED',

	ALBUM_SHOW: 'ALBUM_SHOW',

	ALBUM_ITEM_HOVER: 'ALBUM_ITEM_HOVER',


	//Selection
	CLEAR_ALBUM_ITEMS: 'CLEAR_ALBUM_ITEMS',
	CLEAR_ALBUM_ITEMS_OFFSET: 'CLEAR_ALBUM_ITEMS_OFFSET',
	ALBUM_ITEM_SELECTED: 'ALBUM_ITEM_SELECTED',
	ALBUM_ITEM_DESELECTED: 'ALBUM_ITEM_DESELECTED',
	CLEAR_ALBUM_ITEM_SELECTION: 'CLEAR_ALBUM_ITEM_SELECTION',
	//Creation
	ALBUM_ITEM_CREATION_REQUEST: 'ALBUM_ITEM_CREATION_REQUEST',
	ALBUM_ITEM_CREATED: 'ALBUM_ITEM_CREATED',
	ALBUM_ITEM_CREATION_FAILED: 'ALBUM_ITEM_CREATION_FAILED',
	//Update
	ALBUM_ITEM_UPDATE_REQUEST: 'ALBUM_ITEM_UPDATE_REQUEST',
	ALBUM_ITEM_UPDATED: 'ALBUM_ITEM_UPDATED',
	ALBUM_ITEM_UPDATE_FAILED: 'ALBUM_ITEM_UPDATE_FAILED',
	//Delete
	ALBUM_ITEM_DELETE_REQUEST: 'ALBUM_ITEM_DELETE_REQUEST',
	ALBUM_ITEM_DELETE_REQUESTS: 'ALBUM_ITEM_DELETE_REQUESTS',
	ALBUM_ITEM_DELETED: 'ALBUM_ITEM_DELETED',
	ALBUM_ITEM_DELETE_FAILED: 'ALBUM_ITEM_DELETE_FAILED',

	//Download
	ALBUM_ITEM_DOWNLOAD: 'ALBUM_ITEM_DOWNLOAD',
	ALBUM_ITEM_DOWNLOAD_REQUEST: 'ALBUM_ITEM_DOWNLOAD_REQUEST',
	ALBUM_ITEM_DOWNLOAD_RECIEVED: 'ALBUM_ITEM_DOWNLOAD_RECIEVED',
	ALBUM_ITEM_DOWNLOAD_FAILED: 'ALBUM_ITEM_DOWNLOAD_FAILED',

	ALBUM_ITEMS_UPDATE_REQUESTED: 'ALBUM_ITEMS_UPDATE_REQUESTED',

	ALBUM_ITEMS_ADD_TO_ALBUM_REQUEST: 'ALBUM_ITEMS_ADD_TO_ALBUM_REQUEST',
	ALBUM_ITEMS_ADD_TO_ALBUM_SUCCESS: 'ALBUM_ITEMS_ADD_TO_ALBUM_SUCCESS',
	ALBUM_ITEMS_ADD_TO_ALBUM_FAILURE: 'ALBUM_ITEMS_ADD_TO_ALBUM_FAILURE',

	ALBUM_ITEMS_ADD_TO_PHOTOCD_REQUEST: 'ALBUM_ITEMS_ADD_TO_PHOTOCD_REQUEST',
	ALBUM_ITEMS_ADD_TO_PHOTOCD_SUCCESS: 'ALBUM_ITEMS_ADD_TO_PHOTOCD_SUCCESS',
	ALBUM_ITEMS_ADD_TO_PHOTOCD_FAILURE: 'ALBUM_ITEMS_ADD_TO_PHOTOCD_FAILURE',

	ALBUM_ITEMS_ADD_TO_DVD_REQUEST: 'ALBUM_ITEMS_ADD_TO_DVD_REQUEST',
	ALBUM_ITEMS_ADD_TO_DVD_SUCCESS: 'ALBUM_ITEMS_ADD_TO_DVD_SUCCESS',
	ALBUM_ITEMS_ADD_TO_DVD_FAILURE: 'ALBUM_ITEMS_ADD_TO_DVD_FAILURE',
	//ItemSlider
	ALBUM_ITEMS_SLIDER_REQUEST: 'ALBUM_ITEMS_SLIDER_REQUEST',
	ALBUM_ITEMS_SLIDER_RECEIVED: 'ALBUM_ITEMS_SLIDER_RECEIVED',
	ALBUM_ITEMS_SLIDER_FAILED: 'ALBUM_ITEMS_SLIDER_FAILED',
	CLEAR_ALBUM_ITEMS_SLIDER: 'CLEAR_ALBUM_ITEMS_SLIDER',

	ALBUM_IMAGE_CURRENT_UPDATED: 'ALBUM_IMAGE_CURRENT_UPDATED',
	ALBUM_ITEM_ROTATE_REQUEST: 'ALBUM_ITEM_ROTATE_REQUEST',
	ALBUM_ITEM_ROTATE_SUCCESS: 'ALBUM_ITEM_ROTATE_SUCCESS',
	ALBUM_ITEM_ROTATE_ERROR: 'ALBUM_ITEM_ROTATE_ERROR',
    ALBUM_ITEM_SCROLL: 'ALBUM_ITEM_SCROLL'

};


// WEBPACK FOOTER //
// ./src/album-view/actions/album-item-action-types.js